import { handleApiCall } from "../api";

export interface OrganizationApiDetails {
  id?: number;
  organization_name?: string;
  organization_code?: string;
  logo?: string;
  favicon_url?: string;
  whatsapp_support_number?: string;
  short_description?: string;
  long_description?: string;
  address?: string;
  email?: string;
  contact_number?: string;
  website?: string;
}

export const getOrganizationDetails = (organizationCode: string) =>
  handleApiCall("get", `/organization/${organizationCode}`);

/** @deprecated Use getOrganizationDetails */
export const getOrganizations = getOrganizationDetails;
